/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EntityModelResponseContainerForgotPasswordResponse } from '../models/EntityModelResponseContainerForgotPasswordResponse';
import type { ForgotPasswordRequest } from '../models/ForgotPasswordRequest';
import type { PasswordResetRequest } from '../models/PasswordResetRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class UserMaintenanceControllerService {
    /**
     * @returns EntityModelResponseContainerForgotPasswordResponse OK
     * @throws ApiError
     */
    public static forgotPassword({
        requestBody,
    }: {
        requestBody: ForgotPasswordRequest,
    }): CancelablePromise<EntityModelResponseContainerForgotPasswordResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/forgot_password',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static enableUser({
        requestBody,
    }: {
        requestBody: PasswordResetRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/maintenance/enable-user',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static resetPassword({
        requestBody,
    }: {
        requestBody: PasswordResetRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/maintenance/reset_password',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static emailConfirm({
        token,
    }: {
        token: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/maintenance/verify_email',
            query: {
                'token': token,
            },
        });
    }
}
